import React, { useEffect, useLayoutEffect, useState } from "react";
import request from "../../../../network/request";
import { reportUserBehavior } from "../../../../utils/common";
import useGetCh from "../../../../hooks/useGetCh";
import useQuery from "../../../../hooks/useQuery";
import { ErrorPlaceholder } from "../../../../components/placeholder";
import LoadingHomepage from "../../../maintence/components/LoadingHomepage";
import Progress from "../../../../components/Progress";
import ServiceInfo from "./components/ServiceInfo";
import LocationMap from "./components/LocationMap";
import { useRequest } from "ahooks";

/**
 * 取车服务详情 & 送车服务详情
 * @returns
 */
const GetAndReturnCarServiceDetail = () => {
  const query = useQuery();
  const drivingOrderSubId = query.get("drivingOrderRecordSubId"); // 还车单号
  const subOderType = query.get("subOderType"); // 取车单=103，还车单=204
  // 埋点等保留了以前的处理方式，这里暂时不改
  const ch = useGetCh();
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useLayoutEffect(() => {
    subOderType === "103"
      ? (document.title = "取车服务详情")
      : (document.title = "送车服务详情");
  }, [subOderType]);

  const {
    data: detailData,
    runAsync: getDetailData,
    loading,
  } = useRequest(
    async () => {
      try {
        setError(false);
        const res: any = await request(
          "serviceOrder/getDrivingDetail",
          {
            drivingOrderSubId,
          },
          "post"
        );
        window.scrollTo(0, 0);
        reportUserBehavior({
          so: "J001002",
          mcode: "return_detail__req_get_returns_order_detail_success",
          ch,
          pa: `status=success\`drivingOrderSubId=${drivingOrderSubId}`,
        });
        return res;
      } catch (err) {
        reportUserBehavior({
          so: "J001002",
          mcode: "return_detail__req_get_returns_order_detail_error",
          ch,
          pa: `status=error\`errMessage=${(err as any)?.message}`,
        });
        setError(true);
        setErrorMsg((err as any).message || "获取预约订单失败，请稍后重试");
        return {};
      }
    },
    { manual: true, refreshDeps: [drivingOrderSubId, ch] }
  );

  useEffect(() => {
    getDetailData();
  }, [getDetailData]);

  useEffect(() => {
    if (!loading && !error) {
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "return_detail",
          ch,
          pa: `status=success`,
        },
        "page"
      );
    }
  }, [loading, error, ch]);

  if (loading) {
    return <LoadingHomepage></LoadingHomepage>;
  }

  if (error) {
    reportUserBehavior(
      {
        so: "J001002",
        mcode: "return_detail",
        ch,
        pa: `status=error`,
      },
      "page"
    );
    return (
      <ErrorPlaceholder
        message={errorMsg}
        getData={getDetailData}
      ></ErrorPlaceholder>
    );
  }

  return (
    <div style={{ backgroundColor: "#ffffff" }}>
      <Progress
        progressList={detailData?.statusList}
        currentStatus={detailData?.statusCode}
      />
      <ServiceInfo detailData={detailData} />
      <LocationMap detailData={detailData} />
    </div>
  );
};

export default GetAndReturnCarServiceDetail;
